import React from 'react';
import { Row, Container, Col } from 'reactstrap';

import PaymentPursesNavItem from './PaymentPursesNavItem';

export default ({ wallets, selectPurse, selectedWallet }) => (
  <Row className="payment-nav-row">
    {wallets.map(wallet => (
      <Col xl="4" lg="6" md="6" sm="6" key={wallet.title}>
        <PaymentPursesNavItem
          selected={wallet.type === selectedWallet ? true : false}
          selectPurse={selectPurse}
          key={wallet.title}
          wallet={wallet}
        />
      </Col>
    ))}
  </Row>
);
